const gearboxTranslate: Record<string, string> = {
  'GEARBOX.AUTO': 'Automática',
  'GEARBOX.MANUAL': 'Manual',
}

export default gearboxTranslate
